import { useLocation, useHistory } from "./useRouter";
import { Benefit, initialQueryProps } from "Shared/types/EmployeeProfiles";
import { queryToProps } from "Api";
import { EmploymentStatus, UserStatus } from "Shared/types/EmployeeProfiles";
import InternalRoutes from "Shared/Constants/InternalRoutes";
import { goToPageCreator } from "./useGoTo";
import without from "lodash/without";

export interface UserFilters {
  employmentStatuses: EmploymentStatus[];
  userStatuses: UserStatus[];
  payGroupIds: string[];
  locationIds: string[];
  benefitTypes: Benefit[];
}

export const initialUserFiltersState = {
  employmentStatuses: [EmploymentStatus.EMPLOYED],
  userStatuses: [],
  payGroupIds: [],
  locationIds: [],
};


export const useUserFilters = () => {
  const { search } = useLocation();
  const history = useHistory();
  const queryProps = search === "" ? initialQueryProps : queryToProps(search);
  const userFilters = {
    employmentStatuses: queryProps.employmentStatusFilters,
    userStatuses: queryProps.userStatusFilters,
    payGroupIds: queryProps.payGroupFilters,
    locationIds: queryProps.locationFilters,
    benefitTypes: queryProps.benefitFilters,
  };

  const goToUsersPage = goToPageCreator(history, InternalRoutes.users);

  const applyFilters = (userFilters: UserFilters) => {
    const newUserFilters = {
      ...queryProps,
      userStatusFilters: userFilters.userStatuses,
      employmentStatusFilters: userFilters.employmentStatuses,
      payGroupFilters: userFilters.payGroupIds,
      locationFilters: userFilters.locationIds,
      benefitFilters: userFilters.benefitTypes,
    };
    goToUsersPage(newUserFilters);
  };

  const resetFilters = () => {
    goToUsersPage(initialQueryProps);
  };

  const removeFilter = (filterType: keyof UserFilters, filterValue: string) => {
    const newUserFilters = {
      ...userFilters,
      [filterType]: without(userFilters[filterType], filterValue),
    };
    applyFilters(newUserFilters);
  };

  return {
    userFilters,
    applyFilters,
    resetFilters,
    removeFilter,
  };
};
